module.exports = __webpack_public_path__ + "static/banner-right-img-2-782a350b603c0b257f4e866eea77e0e3.png";